/**
 * Page de debug pour voir le contenu du bootstrap
 */

import { useAccessStore } from '@sphere/auth/data-access';
import { Card, CardHeader, CardTitle, CardContent } from '@sphere/shared/ui/design-system';
import { Tag } from '@carbon/react';
import styles from './BootstrapDebugPage.module.scss';

export default function BootstrapDebugPage() {
  const {
    authenticated,
    bootstrapLoaded,
    user,
    roles,
    sections,
    capabilities,
    scope,
    partial,
  } = useAccessStore();

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h1 className={styles.title}>Debug Bootstrap</h1>
        <p className={styles.subtitle}>
          Informations de connexion et permissions
        </p>
      </div>

      {/* État général */}
      <Card>
        <CardHeader>
          <CardTitle>État général</CardTitle>
        </CardHeader>
        <CardContent className={styles.cardContentGapSm}>
          <div className={styles.row}>
            <span className={styles.rowLabel}>Authentifié:</span>
            <Tag type={authenticated ? 'blue' : 'red'}>
              {authenticated ? 'Oui' : 'Non'}
            </Tag>
          </div>
          <div className={styles.row}>
            <span className={styles.rowLabel}>Bootstrap chargé:</span>
            <Tag type={bootstrapLoaded ? 'blue' : 'red'}>
              {bootstrapLoaded ? 'Oui' : 'Non'}
            </Tag>
          </div>
          <div className={styles.row}>
            <span className={styles.rowLabel}>Mode dégradé:</span>
            <Tag type={partial ? 'gray' : 'blue'}>
              {partial ? 'Oui' : 'Non'}
            </Tag>
          </div>
        </CardContent>
      </Card>

      {/* Utilisateur */}
      <Card>
        <CardHeader>
          <CardTitle>Utilisateur</CardTitle>
        </CardHeader>
        <CardContent>
          <pre className={styles.preBlock}>
            {JSON.stringify(user, null, 2)}
          </pre>
        </CardContent>
      </Card>

      {/* Rôles */}
      <Card>
        <CardHeader>
          <CardTitle>Rôles</CardTitle>
        </CardHeader>
        <CardContent>
          <div className={styles.tagsWrap}>
            {roles.length > 0 ? (
              roles.map((role) => (
                <Tag type="blue" key={role}>
                  {role}
                </Tag>
              ))
            ) : (
              <p className={styles.emptyText}>Aucun rôle</p>
            )}
          </div>
        </CardContent>
      </Card>

      {/* Sections */}
      <Card>
        <CardHeader>
          <CardTitle>Sections visibles</CardTitle>
        </CardHeader>
        <CardContent>
          <pre className={styles.preBlock}>
            {JSON.stringify(sections, null, 2)}
          </pre>
        </CardContent>
      </Card>

      {/* Capabilities */}
      <Card>
        <CardHeader>
          <CardTitle>Capabilities globales</CardTitle>
        </CardHeader>
        <CardContent>
          <pre className={styles.preBlock}>
            {JSON.stringify(capabilities, null, 2)}
          </pre>
        </CardContent>
      </Card>

      {/* Scope */}
      <Card>
        <CardHeader>
          <CardTitle>Scope utilisateur</CardTitle>
        </CardHeader>
        <CardContent>
          <pre className={styles.preBlock}>
            {JSON.stringify(scope, null, 2)}
          </pre>
        </CardContent>
      </Card>

      {/* Diagnostic */}
      <Card>
        <CardHeader>
          <CardTitle>Diagnostic</CardTitle>
        </CardHeader>
        <CardContent className={styles.cardContentGap}>
          <div className={styles.diagnosticSection}>
            <p className={styles.diagnosticTitle}>Sections visibles:</p>
            <ul className={styles.diagnosticList}>
              {Object.entries(sections).map(([key, value]) => (
                <li key={key}>
                  <span className={styles.diagnosticMono}>{key}</span>:{' '}
                  <Tag
                    type={value.visible ? 'blue' : 'gray'}
                    className={styles.tagMargin}
                  >
                    {value.visible ? 'Visible' : 'Cachée'}
                  </Tag>
                </li>
              ))}
            </ul>
          </div>

          <div className={styles.diagnosticSection}>
            <p className={styles.diagnosticTitle}>Capabilities:</p>
            <ul className={styles.diagnosticList}>
              {Object.entries(capabilities).map(([key, value]) => (
                <li key={key}>
                  <span className={styles.diagnosticMono}>{key}</span>:{' '}
                  <span className={styles.smallText}>
                    list: {value.list ? '✓' : '✗'}, create:{' '}
                    {value.create ? '✓' : '✗'}
                  </span>
                </li>
              ))}
            </ul>
          </div>

          <div className={styles.diagnosticSection}>
            <p className={styles.diagnosticTitle}>Scope:</p>
            <ul className={styles.diagnosticList}>
              <li>
                Établissements:{' '}
                {scope.establishmentIds?.length || 0 === 0
                  ? 'Tous'
                  : scope.establishmentIds?.join(', ')}
              </li>
              <li>
                Classes:{' '}
                {scope.classIds?.length || 0 === 0
                  ? 'Toutes'
                  : scope.classIds?.join(', ')}
              </li>
            </ul>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
